import { type Product, type RemoteActionsMetas } from '../../common/types';

export const REMOTE_ACTIONS_KEY = 'atlassian-remote-actions';

export const readRemoteActionsMetasFromLocalStorage = (product: Product): RemoteActionsMetas => {
	try {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		return JSON.parse(localStorage.getItem(`${REMOTE_ACTIONS_KEY}.${product}`) || '{}');
	} catch (e) {
		console.warn('Could not load from localStorage', e);
		return {};
	}
};

export const writeRemoteActionsMetasToLocalStorage = (
	product: Product,
	remoteActionsMetas: RemoteActionsMetas,
): void => {
	try {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.setItem(`${REMOTE_ACTIONS_KEY}.${product}`, JSON.stringify(remoteActionsMetas));
	} catch (e) {
		console.warn('Could not load from localStorage', e);
	}
};
